export default {"src":"/_next/static/media/KBC.15ed5620.svg","height":259,"width":259,"blurWidth":0,"blurHeight":0};